module.exports = "/_next/static/images/bca58d35878034fa40d8002cf4ac3bb0-NoTransferFee.png";